/**
 * @fileoverview ユーティリティ関数
 * @description 汎用的なヘルパー関数を提供
 */
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * クラス名を結合するユーティリティ関数
 * @description clsx と tailwind-merge を組み合わせて、
 *              条件付きクラス名の結合とTailwindクラスの競合解決を行う
 * @param inputs - クラス名（文字列、配列、オブジェクト形式）
 * @returns マージされたクラス名文字列
 * @example
 * cn('px-4 py-2', 'bg-blue-500')
 * // => 'px-4 py-2 bg-blue-500'
 *
 * cn('px-4', { 'bg-blue-500': true, 'bg-red-500': false })
 * // => 'px-4 bg-blue-500'
 *
 * cn('px-4 bg-blue-500', 'bg-red-500')
 * // => 'px-4 bg-red-500' (tailwind-mergeにより競合解決)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
